export default "__VITE_ASSET__D2alO3yV__"